(function() {
    'use strict';
    var popupsBuffer = {};

    Odigeo.UIElements.hint = {};

    const createFreeTapSideEffectsIntegration = (selector) => (element) => $(element).closest(selector).length === 1;
    const isConchitaLike = createFreeTapSideEffectsIntegration('.conchita');
    const isShellIntegrationPortal = createFreeTapSideEffectsIntegration('.shell-integration_portal');
    const isQueryClientDevTools = createFreeTapSideEffectsIntegration('.ReactQueryDevtools');

    Odigeo.UIElements.hint.bindCloseHintsOnPageClick = function(page) {
        Odigeo.UIElements.hint.unbindAllHints();
        $('#flights-root, #dynpack-root').on(Odigeo.Events.tap, function(e) {
            const conchitaLike = isConchitaLike(e.target);
            const shellIntegrationPortal = isShellIntegrationPortal(e.target);
            const queryClientDevToolsPortal = isQueryClientDevTools(e.target);

            if (!conchitaLike && !shellIntegrationPortal && !queryClientDevToolsPortal) {
                Odigeo.Events.fake.trigger('fake:blur', e);
            }

            Odigeo.UIElements.hint.hidePageHints(page);

            if (!shellIntegrationPortal && !conchitaLike && !queryClientDevToolsPortal) {
                e.stopPropagation();
            }
        });
        Odigeo.UIElements.hint.bindPageHints(page);
    };

    Odigeo.UIElements.hint.unbindAllHints = function() {
        Odigeo._.each(Odigeo._.keys(popupsBuffer), function(page) {
            Odigeo._.each(popupsBuffer[page], function($popup) {
                $popup.trigger('hideHint', false);
                $popup.trigger('unBindHint');
            });
        });
    };

    Odigeo.UIElements.hint.bindPageHints = function(page) {
        Odigeo._.each(popupsBuffer[page], function($popup) {
            $popup.trigger('bindHint');
        });
    };

    Odigeo.UIElements.hint.hideAllHints = function() {
        Odigeo._.each(Odigeo._.keys(popupsBuffer), function(page) {
            Odigeo.UIElements.hint.hidePageHints(page);
        });
    };

    Odigeo.UIElements.hint.hidePageHints = function(page) {
        Odigeo._.each(popupsBuffer[page], function($popup) {
            $popup.trigger('hideHint', false);
        });
    };

    Odigeo.UIElements.hint.enhance = function(page, wrapper, newOptions = {}) {
        var $wrapper = wrapper instanceof $ ? wrapper : $(wrapper);
        var options = {
            closeButton: {
                show: true,
                closeButtonText: 'q',
            },
            events: {
                tap: false,
                hover: false,
            },
            hintTriggerButton: {
                hintTriggerButtonText: '9',
                hintTriggerButtonClass: '',
            },
            googleAnalyticsOnOpen: {
                type: '',
                data: {
                    page: page,
                    action: '',
                    label: '',
                },
            },
            googleAnalyticsOnClose: {
                type: '',
                data: {
                    page: page,
                    action: '',
                    label: '',
                },
            },
            googleAnalyticsOnCloseButton: {
                type: '',
                data: {
                    page: page,
                    action: '',
                    label: '',
                },
            },
            trigger: '',
            generateHtml: false,
            wrapperClass: '',
            arrowClass: '',
            closeOthers: true,
            recalculate: false,
            popupHeight: 400,
            popupLinkMaxPosition: 500,
            closeContainer: true,
            blockPageScroll: false,
        };
        var $hintTriggerButton;
        var $closeButton;
        var $hintContainer;
        var $hintArrow;
        var $hintContent;
        var $hintTextContent;
        var $parent;
        var hintText;
        var _show;
        var _hide;
        var _clearTimeOut;
        var _timeOutHide;
        var _toggle;
        var _triggerEvents;
        var _triggerGenericEvent;
        var _triggerSpecificEvent;
        var _bindHint;
        var _unBindHint;
        var _generateHTML;
        var _recalculatePosition;
        var _toggleMainPageScroll;
        var timeOutCloseOnHover;

        // wrapper doesn't exist
        if ($wrapper.length === 0) {
            return false;
        }

        if ($wrapper.attr('data-skip-enhance') === 'true' && !newOptions.forceEnhance) {
            return $wrapper;
        }

        options = $.extend(true, options, newOptions);

        $wrapper.attr({
            'data-skip-enhance': true,
            'data-has-to-close-container': options.closeContainer,
        });

        // set selectors if elements haven't been generated
        $hintTriggerButton = $hintTriggerButton || $wrapper.find('.hint_trigger_button');
        $closeButton = $closeButton || $wrapper.find('.hint_close');
        $hintContainer = $hintContainer || $wrapper.find('.hint_container');

        var triggerAnalyitics = function(analytics, trackEvent) {
            if (trackEvent && Odigeo._.isObject(analytics) && analytics.type !== '') {
                Odigeo.trigger('analytics:tracking', analytics);
            }
        };

        // //////// Handlers //////////
        _show = function(e, trackEvent) {
            _clearTimeOut();
            $hintContainer.addClass('opened');
            triggerAnalyitics(options.googleAnalyticsOnOpen, trackEvent);
            if (options.recalculate || options.forcePosition) {
                _recalculatePosition(options.popupHeight, options.popupLinkMaxPosition, options.forcePosition);
            }

            if (options.blockPageScroll) {
                _toggleMainPageScroll(true);
            }
            _triggerEvents('Show');
            e.stopPropagation();
            e.preventDefault();
        };

        _recalculatePosition = function(popupHeight, popupLinkMaxPosition, forcePosition) {
            let classVertical;
            let classHorizontal;
            if (forcePosition) {
                classVertical = forcePosition.vertical;
                classHorizontal = forcePosition.horizontal;
            } else {
                var top = 'top';
                var bottom = 'bottom';
                var left = 'left';
                var right = 'right';
                var positionPopupLinkTop = $wrapper.offset().top;
                var positionPopupLinkLeft = $wrapper.position().left;
                var actualPositionScrollTop = $(document).scrollTop();
                var isTop = actualPositionScrollTop + popupHeight < positionPopupLinkTop;
                var isLinkLeft = positionPopupLinkLeft > popupLinkMaxPosition;
                classVertical = isTop ? top : bottom;
                classHorizontal = isLinkLeft ? right : left;
            }

            $hintContainer
                .removeClass('odf-popup-bottom-right odf-popup-bottom-left odf-popup-top-left odf-popup-top-right')
                .addClass('odf-popup-' + classVertical + '-' + classHorizontal);
        };

        _timeOutHide = function(e, trackEvent, analytics) {
            _clearTimeOut();
            timeOutCloseOnHover = setTimeout(Odigeo._.bind(_hide, this, e, trackEvent, analytics), 150);
        };

        _clearTimeOut = function() {
            if (timeOutCloseOnHover) {
                clearTimeout(timeOutCloseOnHover);
            }
        };

        _hide = function(e, trackEvent, analytics) {
            $hintContainer
                .find('.hint_txt')
                .scrollTop(0)
                .removeClass('extended');
            $hintContainer.find('.hint_more_content').addClass('hidden');
            $hintContainer.removeClass('opened');
            if (options.blockPageScroll) {
                _toggleMainPageScroll(false);
            }
            _triggerEvents('Hide');
            triggerAnalyitics(analytics, trackEvent);
            e.stopPropagation();
            e.preventDefault();
        };

        _toggle = function(e, showHint) {
            var hideElement = Odigeo._.isUndefined(showHint) ? $hintContainer.hasClass('opened') : !showHint;
            if (hideElement) {
                _hide(e, true, options.googleAnalyticsOnClose);
            } else {
                if (options.closeOthers) {
                    Odigeo.UIElements.hint.hidePageHints(page);
                }
                _show(e, true);
            }
            e.stopPropagation();
            e.preventDefault();
        };

        _triggerEvents = function(eventName) {
            _triggerGenericEvent(eventName);
            _triggerSpecificEvent(eventName);
        };

        _triggerGenericEvent = function(eventName) {
            Odigeo.trigger('ui-hint:' + eventName.toLowerCase(), {element: $wrapper, page: page, closeContainer: options.closeContainer});
        };

        _triggerSpecificEvent = function(eventName) {
            if (options.trigger !== '') {
                Odigeo.trigger(options.trigger + eventName, $wrapper);
            }
        };

        var _closeButtonHide = Odigeo._.partial(_hide, _, true, options.googleAnalyticsOnCloseButton);
        var _hoverShow = Odigeo._.partial(_show, _, false);
        var _hoverTimeOutHide = Odigeo._.partial(_timeOutHide, _, false);
        var _wrapperStopProp = function(e) {
            e.stopPropagation();
        };

        _unBindHint = function() {
            $wrapper.off(Odigeo.Events.tap, _wrapperStopProp);
            $closeButton.off(Odigeo.Events.tap, _closeButtonHide);

            if (options.events.tap) {
                $hintTriggerButton.off(Odigeo.Events.tap, _toggle);
            } else if (options.events.hover) {
                $hintTriggerButton.off(Odigeo.Events.mouseEnter, _hoverShow).off(Odigeo.Events.mouseLeave, _hoverTimeOutHide);

                $hintContainer.off(Odigeo.Events.mouseEnter, _clearTimeOut);

                $wrapper.off(Odigeo.Events.mouseLeave, _hoverTimeOutHide);
            }
        };

        _bindHint = function() {
            $wrapper.off(Odigeo.Events.tap, _wrapperStopProp).on(Odigeo.Events.tap, _wrapperStopProp);
            // Bind Events
            $closeButton.off(Odigeo.Events.tap, _closeButtonHide).on(Odigeo.Events.tap, _closeButtonHide);
            // Events: Tab and hover can not be true at the same time
            if (options.events.tap) {
                $hintTriggerButton.off(Odigeo.Events.tap, _toggle).on(Odigeo.Events.tap, _toggle);
            } else if (options.events.hover) {
                $hintTriggerButton
                    .off(Odigeo.Events.mouseEnter, _hoverShow)
                    .on(Odigeo.Events.mouseEnter, _hoverShow)
                    .off(Odigeo.Events.mouseLeave, _hoverTimeOutHide)
                    .on(Odigeo.Events.mouseLeave, _hoverTimeOutHide);

                $hintContainer.off(Odigeo.Events.mouseEnter, _clearTimeOut).on(Odigeo.Events.mouseEnter, _clearTimeOut);

                $wrapper.off(Odigeo.Events.mouseLeave, _hoverTimeOutHide).on(Odigeo.Events.mouseLeave, _hoverTimeOutHide);
            }
        };

        _generateHTML = function() {
            hintText = $wrapper.html();
            $parent = $wrapper.parent();
            $wrapper
                .detach()
                .empty()
                .addClass(options.wrapperClass)
                .addClass('od-hint-popup');

            // Generate hint close button
            $hintTriggerButton = $('<div>', {class: 'ficon hint_trigger_button', text: options.hintTriggerButton.hintTriggerButtonText}).addClass(
                options.hintTriggerButton.hintTriggerButtonClass
            );
            $wrapper.append($hintTriggerButton);

            // Generate hint container
            $hintContainer = $('<div>', {class: 'od-hint-container hint_container'});

            // Generate hint arrow
            $hintArrow = $('<span>', {class: options.arrowClass === '' ? 'od-hint-arrow' : 'od-hint-arrow ' + options.arrowClass});

            // Generate hint content
            $hintContent = $('<div>', {class: 'od-hint-content'});
            $hintTextContent = $('<div>', {class: 'od-hint-txt hint_txt', html: hintText});

            // Generate hint close button
            if (options.closeButton.show) {
                $closeButton = $('<div>', {class: 'od-hint-close ficon hint_close', text: options.closeButton.closeButtonText});

                $hintContent.append($closeButton);
            }

            $hintContent.append($hintArrow);
            $hintContent.append($hintTextContent);
            $hintContainer.append($hintContent);

            $wrapper.append($hintContainer);
            $parent.append($wrapper);
        };

        _toggleMainPageScroll = function(isDisabling) {
            Odigeo.Device.getViewport().css('overflow-y', isDisabling ? 'hidden' : '');
        };

        // Generate DOM elements for hint
        if (options.generateHtml) {
            _generateHTML();
        }

        _bindHint();

        $wrapper
            .on('showHint', _show)
            .on('hideHint', _hide)
            .on('generateHintHTML', _generateHTML)
            .on('bind', _bindHint)
            .on('unBind', _unBindHint)
            .on('toggle', _toggle);

        // Adding the hint to the buffer per page
        if (!popupsBuffer[page]) {
            popupsBuffer[page] = [];
        }
        popupsBuffer[page].push($wrapper);
        return $wrapper;
    };
})();
